import api from './index';

export default {
  get() {
    return api.get(`/section_images`);
  },
  create(payload) {
    return api.post(`/section_images`, { section_images: payload });
  },
  update(id, payload) {
    return api.put(`/section_images/${id}`, { section_images: payload });
  },
  getImagesPromotion(id) {
    return api.get(`/section_images/promotions/${id}`);
  },
  delete(id) {
    return api.delete(`/section_images/${id}`);
  },
};
